import React from 'react';
import PropTypes from 'prop-types';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import {useSelector} from 'react-redux';
import {getLabwareDataById} from 'stores/selectors/labwareStateSelectors';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import {ExecutionStatus} from 'constants/dataEnum';

import '../../Task.scss';
import {getSdWellGroupName} from 'stores/business/taskListSerialDilutionBusiness';
import TaskDescriptionSerialDilution from './TaskDescriptionSerialDilution';
import SerialDilutionAliquotPipettingProfile from './SerialDilutionAliquotPipettingProfile';

function TaskTransferAliquot({
  task,
  number,
  processedTasks,
  isSelected,
  runtimeMode,
  readOnly,
  executionStatus,
  onEdit,
  onSelectTask,
  showPipettingParameter,
}) {
  const labware = useSelector(getLabwareDataById(task.labwareID));

  const {volume, row, column, rowTipCount, columnTipCount} = task || {};
  const {name: labwareName, rowCount: labwareRowCount, colCount: labwareColumnCount} = labware || {};

  const wellGroupName = getSdWellGroupName(
    row,
    column,
    rowTipCount,
    columnTipCount,
    labwareRowCount,
    labwareColumnCount,
  );

  const taskTitle = `Transfer 100% Sample Concentration ${volume}μL`;

  return (
    <TaskWrapper isSelected={isSelected} onClick={onSelectTask}>
      <TaskNumber number={number} isHighlighted={isSelected} />
      <TaskTitle
        title={taskTitle}
        description={<TaskDescriptionSerialDilution labwareName={labwareName} wellGroup={wellGroupName} />}
      />
      {!runtimeMode && !readOnly && <TaskAction onEdit={onEdit} />}
      {showPipettingParameter && (
        <TaskPipettingProfileWrapper>
          <SerialDilutionAliquotPipettingProfile runtimeMode={runtimeMode} tasks={processedTasks} />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

TaskTransferAliquot.propTypes = {
  runtimeMode: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  processedTasks: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  showPipettingParameter: PropTypes.bool.isRequired,
  number: PropTypes.any.isRequired,
};

export default TaskTransferAliquot;
